import _ from 'lodash';
import EnvSettings from '../../../../config/settings';
import { MESSAGE_TYPE_LINKEDIN, MESSAGE_TYPE_LINKEDIN_INMAIL } from '../index';
import { Recruiter } from '../../core/route/recruiterService';

const getLocationString = function (location) {
    let locationString = '';
    if (location) {
        if (location.city) {
            locationString = location.city;
        }
        if (location.region) {
            if (locationString) {
                locationString += ', ';
            }
            locationString +=
                (location.region || '');
        }
        if (location.state) {
            if (locationString) {
                locationString += ', ';
            }
            locationString +=
                (location.state || '');
        }
        if (location.country) {
            if (locationString) {
                locationString += ', ';
            }
            locationString +=
                location.country;
        }
    }
    return locationString;
};

export default class MessageFormatter {
    static fillTemplate(template, candidateData, recruiterData, positionData, type, employerRep) {
        if (candidateData && template.template) {
            const fullName = this.capitalizeName(candidateData.fullName);
            const [candidateFirstName, ...candidateLastName] = (candidateData.fullName || '').split(' ');
            const firstName = this.capitalizeName(candidateFirstName);
            const lastName = this.capitalizeName(candidateLastName);

            template.template = template.template.replaceAll(
                '<span field=\'prospectName\'></span>',
                `<span field='prospectName'>${fullName}</span>`,
            ).replaceAll(
                '<span field=\'prospectFirstName\'></span>',
                `<span field='prospectFirstName'>${fullName}</span>`,
            ).replaceAll(
                '<span field=\'candidateFirstName\'></span>',
                `<span field='candidateFirstName'>${firstName}</span>`,
            ).replaceAll(
                '<span field=\'candidateLastName\'></span>',
                `<span field='candidateLastName'>${lastName}</span>`,
            );

            const positionApprovalLink = _.get(candidateData, 'positionApprovalLink');
            if (positionApprovalLink) {
                const replacement = [MESSAGE_TYPE_LINKEDIN_INMAIL, MESSAGE_TYPE_LINKEDIN].includes(type)
                    ? `${positionApprovalLink} $1`
                    : `<a href='${positionApprovalLink}'>$1</a>`;

                template.template = template.template.replaceAll(/<a(.*?)\s((field)|(href))=\\?['"]positionApproveLink\\?['"]>/, `${replacement} `);
            }

            if (type === 'profileEmployer') {
                template.template = template.template.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
            } else if (type === 'profileCandidate' && candidateData.talentForCandidateId) {
                template.template = template.template.replaceAll(
                    '<a href=\'link\'>',
                    `<a href='${EnvSettings.Auth0RedirectUrl}#/candidateApproval/${candidateData.talentForCandidateId}/${candidateData.workflow._id}'>`,
                );
            }
        }
        if (recruiterData && template.template) {
            template.template = template.template.replaceAll(
                '<span field=\'teName\'></span>',
                `<span field='teName'>${this.capitalizeName(recruiterData.fullName)}</span>`,
            );

            template.template = template.template.replaceAll(
                '<span field=\'teFirstName\'></span>',
                `<span field='teFirstName'>${this.capitalizeName(recruiterData.fullName)
                    .split(' ')[0]}</span>`,
            );

            if (recruiterData.contact.email.length > 0) {
                template.template = template.template.replaceAll(
                    '<span field=\'teEmail\'></span>',
                    `<span field='teEmail'>${Recruiter.getEmail(recruiterData)}</span>`,
                );
            }

            if (recruiterData.contact.phone.length > 0) {
                template.template = template.template.replaceAll(
                    '<span field=\'tePhone\'></span>',
                    `<span field='tePhone'>${recruiterData.contact.phone[0].value}</span>`,
                );
            }
        }
        if (positionData && template.template) {
            const locationsString = (positionData.locations || [])
                .map(location => getLocationString(location))
                .join(' OR ');

            template.template = template.template
                .replaceAll(
                    '<span field=\'jobTitle\'></span>',
                    `<span field='jobTitle'>${this.capitalizeName(positionData.jobTitle)}</span>`,
                ).replaceAll(
                    '<span field=\'employerName\'></span>',
                    `<span field='employerName'>${this.capitalizeName(positionData.employerData.name)}</span>`,
                )
                .replaceAll(
                    '<span field=\'employerCompanyWebsite\'></span>',
                    `<a field='employerCompanyWebsite' target="_blank">${_.get(positionData, 'employerData.contact.webAddress.0.value', '')}</a>`,
                )
                .replaceAll(
                    '<span field=\'location\'></span>',
                    `<span field='location'>${positionData.locationString}</span>`,
                )
                .replaceAll(
                    '<span field=\'positionLocation\'></span>',
                    `<span field='positionLocation'>${locationsString}</span>`,
                );

            if (type === 'profilesEmployer') {
                template.template = template.template.replaceAll(
                    '<a href=\'link\'>',
                    `<a href='${EnvSettings.Auth0RedirectUrl}#/employer/${
                        positionData.employerId}/candidatesJob/${
                        positionData._id}/` +
                    'workflowStep/Prospect/candidatesPage/1/scroll/0/candidate/' + '\'>',
                );
            } else if (type === 'feedbackEmployer') {
                template.template = template.template.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
            }
        }

        if (employerRep && template.template) {
            template.template = template.template
                .replaceAll(
                    '<span field=\'employerRepName\'></span>',
                    `<span field='employerRepName'>${employerRep.name}</span>`,
                )
                .replaceAll(
                    '<span field=\'employerRepEmail\'></span>',
                    `<span field='employerRepEmail'>${employerRep.email}</span>`,
                )
                .replaceAll(
                    '<span field=\'employerRepPhone\'></span>',
                    `<span field='employerRepPhone'>${_.get(employerRep, 'phones.0.value', '')}</span>`,
                )
                .replaceAll(
                    '<span field=\'employerRepJobTitle\'></span>',
                    `<span field='employerRepJobTitle'>${_.get(employerRep, 'title', '')}</span>`,
                );
        }

        if (template.subject) {
            if (candidateData) {
                const fullName = this.capitalizeName(candidateData.fullName);
                const [candidateFirstName, ...candidateLastName] = (candidateData.fullName || '').split(' ');
                const firstName = this.capitalizeName(candidateFirstName);
                const lastName = this.capitalizeName(candidateLastName);

                template.subject = template.subject.replaceAll(
                    '<span field=\'prospectName\'></span>',
                    `<span field='prospectName'>${fullName}</span>`,
                ).replaceAll(
                    '<span field=\'prospectFirstName\'></span>',
                    `<span field='prospectFirstName'>${fullName}</span>`,
                ).replaceAll(
                    '<span field=\'candidateFirstName\'></span>',
                    `<span field='candidateFirstName'>${firstName}</span>`,
                ).replaceAll(
                    '<span field=\'candidateLastName\'></span>',
                    `<span field='candidateLastName'>${lastName}</span>`,
                );

                if (type === 'profileEmployer') {
                    template.subject = template.subject.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
                }
            }

            if (recruiterData) {
                template.subject = template.subject.replaceAll(
                    '<span field=\'teName\'></span>',
                    `<span field='teName'>${this.capitalizeName(recruiterData.fullName)}</span>`,
                );

                template.subject = template.subject.replaceAll(
                    '<span field=\'teFirstName\'></span>',
                    `<span field='teFirstName'>${this.capitalizeName(recruiterData.fullName)
                        .split(' ')[0]}</span>`,
                );

                if (recruiterData.contact.email.length > 0) {
                    template.subject = template.subject.replaceAll(
                        '<span field=\'teEmail\'></span>',
                        `<span field='teEmail'>${Recruiter.getEmail(recruiterData)}</span>`,
                    );
                }

                if (recruiterData.contact.phone.length > 0) {
                    template.subject = template.subject.replaceAll(
                        '<span field=\'tePhone\'></span>',
                        `<span field='tePhone'>${recruiterData.contact.phone[0].value}</span>`,
                    );
                }
            }

            if (positionData) {
                const locationsString = (positionData.locations || [])
                    .map(location => getLocationString(location))
                    .join(' OR ');

                template.subject = template.subject
                    .replaceAll(
                        '<span field=\'jobTitle\'></span>',
                        `<span field='jobTitle'>${this.capitalizeName(positionData.jobTitle)}</span>`,
                    )
                    .replaceAll(
                        '<span field=\'employerName\'></span>',
                        `<span field='employerName'>${this.capitalizeName(positionData.employerData.name)}</span>`,
                    )
                    .replaceAll(
                        '<span field=\'employerCompanyWebsite\'></span>',
                        `<a field='employerCompanyWebsite' target="_blank">${_.get(positionData, 'employerData.contact.webAddress.0.value', '')}</a>`,
                    )
                    .replaceAll(
                        '<span field=\'location\'></span>',
                        `<span field='location'>${positionData.locationString}</span>`,
                    )
                    .replaceAll(
                        '<span field=\'positionLocation\'></span>',
                        `<span field='positionLocation'>${locationsString}</span>`,
                    );

                if (type === 'profilesEmployer') {
                    template.subject = template.subject.replaceAll(
                        '<a href=\'link\'>',
                        `<a href='${EnvSettings.Auth0RedirectUrl}#/employer/${
                            positionData.employerId}/candidatesJob/${
                            positionData._id}/` +
                        'workflowStep/Prospect/candidatesPage/1/scroll/0/candidate/' + '\'>',
                    );
                } else if (type === 'feedbackEmployer') {
                    template.subject = template.subject.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
                }

                if (employerRep) {
                    template.subject = template.subject
                        .replaceAll(
                            '<span field=\'employerRepName\'></span>',
                            `<span field='employerRepName'>${employerRep.name}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'employerRepEmail\'></span>',
                            `<span field='employerRepEmail'>${employerRep.email}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'employerRepPhone\'></span>',
                            `<span field='employerRepPhone'>${_.get(employerRep, 'phones.0.value', '')}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'employerRepJobTitle\'></span>',
                            `<span field='employerRepJobTitle'>${_.get(employerRep, 'title', '')}</span>`,
                        );
                }
            }
        }

        return template;
    }

    static capitalizeName(fullName) {
        return (fullName || '').toString().split(' ').reduce((resultName, currentName) => {
            const [firstLetter, ...otherNameLetters] = [...currentName];

            if (firstLetter) {
                const capitalizedName = `${firstLetter.toUpperCase()}${otherNameLetters.join('')}`;

                return `${resultName}${capitalizedName} `;
            }

            return resultName;
        }, '').trim();
    }

    static getTokenizedTemplate(template) {
        const { template: message, subject } = template;

        return {
            ...template,
            subject: this.mapSpanToToken(subject),
            message: this.mapSpanToToken(message),
        };
    }

    static getOrderedTokens() {
        return [
            '%prospectName%',
            '%prospectFirstName%',
            '%candidateFirstName%',
            '%candidateLastName%',
            '%teName%',
            '%teFirstName%',
            '%teEmail%',
            '%tePhone%',
            '%jobTitle%',
            '%employerName%',
            '%prospectFirstName%',
            '%teName%',
            '%teFirstName%',
            '%teEmail%',
            '%tePhone%',
            '%jobTitle%',
            '%employerName%',
            '%positionApproveLink%',
            '%employerCompanyWebsite%',
            '%positionLocation%',
            '%location%',
            '%employerRepName%',
            '%employerRepEmail%',
            '%employerRepPhone%',
            '%employerRepJobTitle%',
        ];
    }

    static getOrderedSpans() {
        return [
            '<span field=\'prospectName\'></span>',
            '<span field=\'prospectFirstName\'></span>',
            '<span field=\'candidateFirstName\'></span>',
            '<span field=\'candidateLastName\'></span>',
            '<span field=\'teName\'></span>',
            '<span field=\'teFirstName\'></span>',
            '<span field=\'teEmail\'></span>',
            '<span field=\'tePhone\'></span>',
            '<span field=\'jobTitle\'></span>',
            '<span field=\'employerName\'></span>',
            '<span field=\'prospectFirstName\'></span>',
            '<span field=\'teName\'></span>',
            '<span field=\'teFirstName\'></span>',
            '<span field=\'teEmail\'></span>',
            '<span field=\'tePhone\'></span>',
            '<span field=\'jobTitle\'></span>',
            '<span field=\'employerName\'></span>',
            '<a href=\'positionApproveLink\'></a>',
            '<a field=\'employerCompanyWebsite\'></a>',
            '<span href=\'positionLocation\'></span>',
            '<span href=\'location\'></span>',
            '<span href=\'employerRepName\'></span>',
            '<span href=\'employerRepEmail\'></span>',
            '<span href=\'employerRepPhone\'></span>',
            '<span href=\'employerRepJobTitle\'></span>',
        ];
    }

    static mapSpanToToken(str) {
        const orderedSpans = this.getOrderedSpans();
        const orderedTokens = this.getOrderedTokens();

        return orderedSpans.reduce((prevStr, orderedSpan, index) =>
            (prevStr.replaceAll(orderedSpan, orderedTokens[index])), str || '');
    }

    static mapTokenToSpan(str) {
        const orderedSpans = this.getOrderedSpans();
        const orderedTokens = this.getOrderedTokens();

        return orderedTokens.reduce((prevStr, orderedToken, index) =>
            (prevStr.replaceAll(orderedToken, orderedSpans[index])), str || '');
    }
}
